import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/library", label: "资源库" },
  { to: "/faq", label: "常见问题" },
  { to: "/about", label: "关于我们" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const isActive = (to: string) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <nav className="flex items-center justify-between h-16 md:h-18" aria-label="主导航">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap"
            aria-label="香蕉动漫首页"
          >
            <span className="w-9 h-9 rounded-xl bg-primary-500 flex items-center justify-center text-foreground-950">
              <i className="ri-movie-2-line text-lg" aria-hidden="true"></i>
            </span>
            <span className="font-heading text-xl text-foreground-950">
              香蕉<span className="text-primary-600">动漫</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-full text-sm whitespace-nowrap transition-colors ${
                  isActive(link.to)
                    ? "bg-primary-500 text-foreground-950 font-medium"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/library"
              className="ml-2 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-colors"
            >
              开始找番
            </Link>
          </div>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 text-foreground-900 cursor-pointer"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"} aria-hidden="true"></i>
          </button>
        </nav>
      </div>

      {open && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-3">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-3 rounded-xl text-sm ${
                  isActive(link.to)
                    ? "bg-primary-500 text-foreground-950 font-medium"
                    : "text-foreground-800 hover:bg-background-100"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}